import { DiscriminationKey } from "./type"
import { discriminateSpace } from "./space-discriminator"

export { DiscriminationKey, discriminateSpace }

export default discriminateSpace
